'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var debug = require('debug');

var EventEmitter = require('events');

var errcode = require('err-code');

var PeerInfo = require('peer-info');

var MulticodecTopology = require('libp2p-interfaces/src/topology/multicodec-topology');

var message = require('./message');

var Peer = require('./peer');

var utils = require('./utils');

var _require = require('./message/sign'),
    signMessage = _require.signMessage,
    verifySignature = _require.verifySignature;

function validateRegistrar(registrar) {
  // registrar handling
  if (typeof registrar !== 'object') {
    throw new Error('a registrar object is required');
  }

  if (typeof registrar.handle !== 'function') {
    throw new Error('a handle function must be provided in registrar');
  }

  if (typeof registrar.register !== 'function') {
    throw new Error('a register function must be provided in registrar');
  }

  if (typeof registrar.unregister !== 'function') {
    throw new Error('a unregister function must be provided in registrar');
  }
}
/**
 * PubsubBaseProtocol handles the peers and connections logic for pubsub routers
 */


var PubsubBaseProtocol = /*#__PURE__*/function (_EventEmitter) {
  _inherits(PubsubBaseProtocol, _EventEmitter);

  var _super = _createSuper(PubsubBaseProtocol);

  /**
   * @param {Object} props
   * @param {String} props.debugName log namespace
   * @param {Array<string>|string} props.multicodecs protocol identificers to connect
   * @param {PeerInfo} props.peerInfo peer's peerInfo
   * @param {Object} props.registrar registrar for libp2p protocols
   * @param {function} props.registrar.handle
   * @param {function} props.registrar.register
   * @param {function} props.registrar.unregister
   * @param {boolean} [props.signMessages] if messages should be signed, defaults to true
   * @param {boolean} [props.strictSigning] if message signing should be required, defaults to true
   * @abstract
   */
  function PubsubBaseProtocol(_ref) {
    var _this;

    var debugName = _ref.debugName,
        multicodecs = _ref.multicodecs,
        peerInfo = _ref.peerInfo,
        registrar = _ref.registrar,
        _ref$signMessages = _ref.signMessages,
        signMessages = _ref$signMessages === void 0 ? true : _ref$signMessages,
        _ref$strictSigning = _ref.strictSigning,
        strictSigning = _ref$strictSigning === void 0 ? true : _ref$strictSigning;

    _classCallCheck(this, PubsubBaseProtocol);

    if (typeof debugName !== 'string') {
      throw new Error('a debugname `string` is required');
    }

    if (!multicodecs) {
      throw new Error('multicodecs are required');
    }

    if (!PeerInfo.isPeerInfo(peerInfo)) {
      throw new Error('peer info must be an instance of `peer-info`');
    }

    validateRegistrar(registrar);
    _this = _super.call(this);
    _this.log = debug(debugName);
    _this.log.err = debug("".concat(debugName, ":error"));
    _this.multicodecs = utils.ensureArray(multicodecs);
    _this.peerInfo = peerInfo;
    _this.registrar = registrar;
    _this.started = false;
    /**
     * Map of topics to which peers are subscribed to
     *
     * @type {Map<string, Peer>}
     */

    _this.topics = new Map();
    /**
     * Map of peers.
     *
     * @type {Map<string, Peer>}
     */

    _this.peers = new Map(); // Message signing

    if (signMessages) {
      _this.peerId = _this.peerInfo.id;
    }
    /**
     * If message signing should be required for incoming messages
     * @type {boolean}
     */


    _this.strictSigning = strictSigning;
    _this._registrarId = undefined;
    _this._onIncomingStream = _this._onIncomingStream.bind(_assertThisInitialized(_this));
    _this._onPeerConnected = _this._onPeerConnected.bind(_assertThisInitialized(_this));
    _this._onPeerDisconnected = _this._onPeerDisconnected.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Register the pubsub protocol onto the libp2p node.
   * @returns {Promise<void>}
   */


  _createClass(PubsubBaseProtocol, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var topology;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.started) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                this.log('starting'); // Incoming streams

                this.registrar.handle(this.multicodecs, this._onIncomingStream); // register protocol with topology

                topology = new MulticodecTopology({
                  multicodecs: this.multicodecs,
                  handlers: {
                    onConnect: this._onPeerConnected,
                    onDisconnect: this._onPeerDisconnected
                  }
                });
                _context.next = 7;
                return this.registrar.register(topology);

              case 7:
                this._registrarId = _context.sent;
                this.log('started');
                this.started = true;

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
    /**
     * Unregister the pubsub protocol and the streams with other peers will be closed.
     * @returns {Promise}
     */

  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.started) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.next = 4;
                return this.registrar.unregister(this._registrarId);

              case 4:
                this.log('stopping');
                this.peers.forEach(function (peer) {
                  return peer.close();
                });
                this.peers = new Map();
                this.started = false;
                this.log('stopped');

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
    /**
     * On an incoming stream event.
     * @private
     * @param {Object} props
     * @param {string} props.protocol
     * @param {DuplexStream} props.strean
     * @param {Connection} props.connection connection
     */

  }, {
    key: "_onIncomingStream",
    value: function () {
      var _onIncomingStream2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
        var protocol, stream, connection, peerInfo, idB58Str, peer;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                protocol = _ref2.protocol, stream = _ref2.stream, connection = _ref2.connection;
                _context3.next = 3;
                return PeerInfo.create(connection.remotePeer);

              case 3:
                peerInfo = _context3.sent;
                peerInfo.protocols.add(protocol);
                idB58Str = peerInfo.id.toB58String();
                peer = this._addPeer(peerInfo);

                this._processMessages(idB58Str, stream, peer);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _onIncomingStream(_x) {
        return _onIncomingStream2.apply(this, arguments);
      }

      return _onIncomingStream;
    }()
    /**
     * Registrar notifies a connection successfully with pubsub protocol.
     * @private
     * @param {PeerInfo} peerInfo remote peer info
     * @param {Connection} conn connection to the peer
     */

  }, {
    key: "_onPeerConnected",
    value: function () {
      var _onPeerConnected2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(peerInfo, conn) {
        var idB58Str, peer, _yield$conn$newStream, stream;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                idB58Str = peerInfo.id.toB58String();
                this.log('connected', idB58Str);
                peer = this._addPeer(peerInfo);
                _context4.prev = 3;
                _context4.next = 6;
                return conn.newStream(this.multicodecs);

              case 6:
                _yield$conn$newStream = _context4.sent;
                stream = _yield$conn$newStream.stream;
                peer.attachConnection(stream);
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](3);
                this.log.err(_context4.t0);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 11]]);
      }));

      function _onPeerConnected(_x2, _x3) {
        return _onPeerConnected2.apply(this, arguments);
      }

      return _onPeerConnected;
    }()
    /**
     * Registrar notifies a closing connection with pubsub protocol.
     * @private
     * @param {PeerInfo} peerInfo peer info
     * @param {Error} err error for connection end
     */

  }, {
    key: "_onPeerDisconnected",
    value: function _onPeerDisconnected(peerInfo, err) {
      var idB58Str = peerInfo.id.toB58String();
      var peer = this.peers.get(idB58Str);
      this.log('connection ended', idB58Str, err ? err.message : '');

      this._removePeer(peer);
    }
    /**
     * Add a new connected peer to the peers map.
     * @private
     * @param {PeerInfo} peerInfo peer info
     * @returns {PeerInfo}
     */

  }, {
    key: "_addPeer",
    value: function _addPeer(peerInfo) {
      var _this2 = this;

      var id = peerInfo.id.toB58String();
      var existing = this.peers.get(id);

      if (!existing) {
        this.log('new peer', id);
        var peer = new Peer(peerInfo);
        this.peers.set(id, peer);
        existing = peer;
        peer.once('close', function () {
          return _this2._removePeer(peer);
        });
      }

      return existing;
    }
    /**
     * Remove a peer from the peers map.
     * @private
     * @param {Peer} peer peer state
     * @returns {PeerInfo}
     */

  }, {
    key: "_removePeer",
    value: function _removePeer(peer) {
      if (!peer) return;
      var id = peer.info.id.toB58String();
      this.log('delete peer', id);
      this.peers.delete(id);
      return peer;
    }
    /**
     * Validates the given message. The signature will be checked for authenticity.
     * @param {rpc.RPC.Message} message
     * @returns {Promise<Boolean>}
     */

  }, {
    key: "validate",
    value: function () {
      var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(message) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this.strictSigning && !message.signature)) {
                  _context5.next = 3;
                  break;
                }

                this.log('Signing required and no signature was present, dropping message:', message);
                return _context5.abrupt("return", false);

              case 3:
                if (!message.signature) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return", verifySignature(message));

              case 7:
                return _context5.abrupt("return", true);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function validate(_x4) {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
    /**
     * Normalizes the message and signs it, if signing is enabled
     * @private
     * @param {Message} message
     * @returns {Promise<Message>}
     */

  }, {
    key: "_buildMessage",
    value: function _buildMessage(message) {
      var msg = utils.normalizeOutRpcMessage(message);

      if (this.peerId) {
        return signMessage(this.peerId, msg);
      } else {
        return message;
      }
    }
    /**
     * Get a list of the peer-ids that are subscribed to one topic.
     * @param {string} topic
     * @returns {Array<string>}
     */

  }, {
    key: "getSubscribers",
    value: function getSubscribers(topic) {
      if (!this.started) {
        throw errcode(new Error('not started yet'), 'ERR_NOT_STARTED_YET');
      }

      if (!topic || typeof topic !== 'string') {
        throw errcode(new Error('a string topic must be provided'), 'ERR_NOT_VALID_TOPIC');
      }

      return Array.from(this.peers.values()).filter(function (peer) {
        return peer.topics.has(topic);
      }).map(function (peer) {
        return peer.info.id.toB58String();
      });
    }
    /**
     * Overriding the implementation of publish should handle the appropriate algorithms for the publish/subscriber implementation.
     * For example, a Floodsub implementation might simply publish each message to each topic for every peer
     * @abstract
     * @param {Array<string>|string} topics
     * @param {Array<any>|any} messages
     * @returns {Promise}
     *
     */

  }, {
    key: "publish",
    value: function publish(topics, messages) {
      throw errcode(new Error('publish must be implemented by the subclass'), 'ERR_NOT_IMPLEMENTED');
    }
    /**
     * Overriding the implementation of subscribe should handle the appropriate algorithms for the publish/subscriber implementation.
     * For example, a Floodsub implementation might simply send a message for every peer showing interest in the topics
     * @abstract
     * @param {Array<string>|string} topics
     * @returns {void}
     */

  }, {
    key: "subscribe",
    value: function subscribe(topics) {
      throw errcode(new Error('subscribe must be implemented by the subclass'), 'ERR_NOT_IMPLEMENTED');
    }
    /**
     * Overriding the implementation of unsubscribe should handle the appropriate algorithms for the publish/subscriber implementation.
     * For example, a Floodsub implementation might simply send a message for every peer revoking interest in the topics
     * @abstract
     * @param {Array<string>|string} topics
     * @returns {void}
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe(topics) {
      throw errcode(new Error('unsubscribe must be implemented by the subclass'), 'ERR_NOT_IMPLEMENTED');
    }
    /**
     * Overriding the implementation of getTopics should handle the appropriate algorithms for the publish/subscriber implementation.
     * Get the list of subscriptions the peer is subscribed to.
     * @abstract
     * @returns {Array<string>}
     */

  }, {
    key: "getTopics",
    value: function getTopics() {
      throw errcode(new Error('getTopics must be implemented by the subclass'), 'ERR_NOT_IMPLEMENTED');
    }
    /**
     * Overriding the implementation of _processMessages should keep the connection and is
     * responsible for processing each RPC message received by other peers.
     * @abstract
     * @param {string} idB58Str peer id string in base58
     * @param {Connection} conn connection
     * @param {Peer} peer A Pubsub Peer
     * @returns {void}
     *
     */

  }, {
    key: "_processMessages",
    value: function _processMessages(idB58Str, conn, peer) {
      throw errcode(new Error('_processMessages must be implemented by the subclass'), 'ERR_NOT_IMPLEMENTED');
    }
  }]);

  return PubsubBaseProtocol;
}(EventEmitter);

module.exports = PubsubBaseProtocol;
module.exports.message = message;
module.exports.utils = utils;